import styled from '@emotion/styled';

interface Props {
  // Flex properties
  display?: 'flex' | 'inline-flex';
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  gap?: string | number;
  flex?: string | number;
  flexGrow?: number;
  flexShrink?: number;
  flexBasis?: string | number;

  // Dimension properties
  width?: string | number;
  height?: string | number;
  minWidth?: string | number;
  minHeight?: string | number;
  maxWidth?: string | number;
  maxHeight?: string | number;

  // Spacing properties
  padding?: string | number;
  margin?: string | number;

  // Position properties
  position?: 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';
  top?: string | number;
  right?: string | number;
  bottom?: string | number;
  left?: string | number;
  zIndex?: number;

  // Visual properties
  backgroundColor?: string;
  borderRadius?: string | number;
  boxShadow?: string;
  opacity?: number;

  // Overflow properties
  overflow?: 'visible' | 'hidden' | 'scroll' | 'auto';
  overflowX?: 'visible' | 'hidden' | 'scroll' | 'auto';
  overflowY?: 'visible' | 'hidden' | 'scroll' | 'auto';

  // Cursor properties
  cursor?: 'pointer' | 'default' | 'not-allowed' | 'wait' | 'text' | 'move';
}

export const Div = styled.div<Props>`
  ${({ display }) => display && `display: ${display}`};
  ${({ flexDirection }) => flexDirection && `flex-direction: ${flexDirection}`};
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent}`};
  ${({ alignItems }) => alignItems && `align-items: ${alignItems}`};
  ${({ flexWrap }) => flexWrap && `flex-wrap: ${flexWrap}`};
  ${({ gap }) => gap && `gap: ${typeof gap === 'number' ? `${gap}px` : gap}`};
  ${({ flex }) => flex && `flex: ${flex}`};
  ${({ flexGrow }) => flexGrow !== undefined && `flex-grow: ${flexGrow}`};
  ${({ flexShrink }) => flexShrink !== undefined && `flex-shrink: ${flexShrink}`};
  ${({ flexBasis }) => flexBasis && `flex-basis: ${typeof flexBasis === 'number' ? `${flexBasis}px` : flexBasis}`};

  ${({ width }) => width && `width: ${typeof width === 'number' ? `${width}px` : width}`};
  ${({ height }) => height && `height: ${typeof height === 'number' ? `${height}px` : height}`};
  ${({ minWidth }) => minWidth && `min-width: ${typeof minWidth === 'number' ? `${minWidth}px` : minWidth}`};
  ${({ minHeight }) => minHeight && `min-height: ${typeof minHeight === 'number' ? `${minHeight}px` : minHeight}`};
  ${({ maxWidth }) => maxWidth && `max-width: ${typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth}`};
  ${({ maxHeight }) => maxHeight && `max-height: ${typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight}`};

  ${({ padding }) => padding && `padding: ${typeof padding === 'number' ? `${padding}px` : padding}`};
  ${({ margin }) => margin && `margin: ${typeof margin === 'number' ? `${margin}px` : margin}`};

  ${({ position }) => position && `position: ${position}`};
  ${({ top }) => top !== undefined && `top: ${typeof top === 'number' ? `${top}px` : top}`};
  ${({ right }) => right !== undefined && `right: ${typeof right === 'number' ? `${right}px` : right}`};
  ${({ bottom }) => bottom !== undefined && `bottom: ${typeof bottom === 'number' ? `${bottom}px` : bottom}`};
  ${({ left }) => left !== undefined && `left: ${typeof left === 'number' ? `${left}px` : left}`};
  ${({ zIndex }) => zIndex !== undefined && `z-index: ${zIndex}`};

  ${({ backgroundColor }) => backgroundColor && `background-color: ${backgroundColor}`};
  ${({ borderRadius }) =>
    borderRadius && `border-radius: ${typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius}`};
  ${({ boxShadow }) => boxShadow && `box-shadow: ${boxShadow}`};
  ${({ opacity }) => opacity !== undefined && `opacity: ${opacity}`};

  ${({ overflow }) => overflow && `overflow: ${overflow}`};
  ${({ overflowX }) => overflowX && `overflow-x: ${overflowX}`};
  ${({ overflowY }) => overflowY && `overflow-y: ${overflowY}`};

  ${({ cursor }) => cursor && `cursor: ${cursor}`};
`;
